import { gql } from 'graphql-tag';

import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

import { type BankAccount } from '../../accounting';

const SET_BANK_ACCOUNTS = gql`
  mutation Idf538ea205909aa6008dd951dd228ed92(
    $companyId: ID!
    $accountsUpdates: [BankAccountUpdate!]!
  ) {
    __typename
  }
`;

type Payload = {
  accountsUpdates: BankAccount[];
};

type RawResponse = {
  setBankAccounts: {
    reason?: string;
  };
};

export const useSetBankAccountsMutation = (): MutationState<Payload> => {
  return useMutation<Payload, RawResponse>({
    request: {
      type: 'graphQL',
      target: 'v2',
      query: SET_BANK_ACCOUNTS,
    },
    reshapeData: (data) => {
      if (data.setBankAccounts.reason) {
        throw new Error(data.setBankAccounts.reason);
      }
    },
    options: {
      onSuccess: (data): void => {
        data.client.invalidateQueries('getBankAccounts');
        data.client.invalidateQueries('useIntegrationStatusQuery');
      },
    },
  });
};
